// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3StEC","icon":"styles_icon__1WVQE"};